import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Country, Order} from "../../../../store/state/order.state";
import {ChangeSet} from "../../history/order-history.model";

@Component({
    selector: 'billing-preview',
    templateUrl: './billing-info-preview.template.html',
    styleUrls: ['./billing-info-preview.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BillingInfoPreviewComponent implements OnInit {

	@Input() order: Order;
	@Input() countries: Country[];
	@Input() changeSet: ChangeSet;
	@Input() editable = true;
	@Input() multipleAppearance = false;

	@Output() openEditMode: EventEmitter<any> = new EventEmitter<any>();
	contactDetailsChangeSet: ChangeSet;

	ngOnInit() {
		if (this.changeSet) {
			const company = this.changeSet.changes.billingInformationsChanges.billingCompany;
			const contactPerson = this.changeSet.changes.billingInformationsChanges.billingContactPersonChanges;

			this.contactDetailsChangeSet = {
				...this.changeSet,
				changes: {
					...this.changeSet.changes,
					company: {...company},
					contactPerson: {...contactPerson},
				}
			};
		}
	}

	goToEditMode() {
		this.openEditMode.emit();
	}

	isPurchaseNumberChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.billingInformationsChanges.purchaseOrderNumber;
	}

	isAdditionalInformationChanged() {
		return !!this.changeSet && !!this.changeSet.changes.billingInformationsChanges.additionalInformation;
	}

	isPurchaseRequiredChanged() {
		return !!this.changeSet && !!this.changeSet.changes.billingInformationsChanges.isPurchaseNumberRequiredForPayment;
	}

	isCoverTravelExpensesChanged() {
		return !!this.changeSet && !!this.changeSet.changes.billingInformationsChanges.coverTravelExpenses;
	}

	isSameCompanyChanged() {
		return !!this.changeSet
			&& !!this.changeSet.changes.billingInformationsChanges.sameCompanyAndContactPersonAsProvided
			&& this.changeSet.changes.billingInformationsChanges.sameCompanyAndContactPersonAsProvided.currentValue
			&& (!!this.contactDetailsChangeSet.changes.contactPerson || !!this.contactDetailsChangeSet.changes.company);
	}

	uniqueName(controlName: string) {
		if (this.multipleAppearance) {
			// added milliseconds to distinguish radio buttons in different components: UMB-5539
			// dynamic name causes 'Expression has changed after it was checked` Error.
			// So for components where multiple billings preferences can appear (like history components) was introduced multipleAppearance flag.
			return controlName + new Date().getMilliseconds();
		}

		return controlName;
	}
}
